module.exports = __webpack_public_path__ + "img/stats_cards.7424d8e9.png";